import { ReactNode } from "react";
import { Link } from "react-router-dom";

import { Button, Divider, Grid, Stack } from "@mui/material";

import AlertExtended from "../../common/components/mui-extended/AlertExtended";
import { Crud } from "../RoutesConfig";

type SuccessProps = {
  title?: string;
  routePath: Crud;
  children: ReactNode;
};

export default function Success({ title, routePath, children: content }: SuccessProps) {
  return (
    <Stack spacing={2}>
      <Divider sx={{ mb: "10px" }} />
      <AlertExtended type="success" title={title ? title : "Успешно вписване"}>
        {content}
      </AlertExtended>
      <Grid container justifyContent="end">
        <Button component={Link} to={routePath.Search.Path} replace={true} startIcon={routePath.Root.Icon}>
          {routePath.Root.Label}
        </Button>
      </Grid>
    </Stack>
  );
}
